export class SetExtra<T> extends Set<T> {
    public addAll(values: T[]): void {
        values.forEach((value) => this.add(value))
    }

    public getValuesAsArray(): T[] {
        return Array.from(this.values())
    }
}
